var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import renderText from './renderText';
import widgetConfig from '../core/utils/widgetConfig';
import widgetStyleDetection from './widgetStyleDetection';
import events from './events';
import statistics from '../core/utils/statistics';
import '../core/styling/base.scss';
import getIdFromLocation from "../core/utils/getIdFromLocation";
// Verify widget can load
var verifyWidget = function (config) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve) {
                resolve(true);
                // api.options({
                //     'X-Widget-Id': config._id,
                //     'X-Widget-Instance-Id': config._widgetInstanceId,
                //     'X-Customer-Id': config._customerId,
                // })
                //     .then(() => {
                //         resolve(true)
                //     })
                //     .catch(() => {
                //         resolve(false)
                //     })
            })];
    });
}); };
// Common things we need to setup is done here.
var widgetBootstrap = function (config, dom, _dangeriousBypass) { return __awaiter(void 0, void 0, void 0, function () {
    var personId, freshConfig, link, apiUrl, canRender;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!config.layout.length) {
                    personId = getIdFromLocation(window.location);
                    if (personId) {
                        //load detail
                        config.layout = [{
                                type: 'rememberMe',
                                options: {},
                                hooks: {},
                                views: {}
                            }];
                    }
                    else {
                        // load index
                        config.layout = [{
                                type: 'search',
                                options: {
                                    simplesearch: true, // If you want only a single input field
                                }
                            }, {
                                type: 'feed',
                                options: {
                                    // detailPage: 'detail.html?id={id}',
                                    numOfCards: 12,
                                    // municipality: 'Heerenveen',
                                    // pagination: true,
                                },
                                hooks: {
                                    onClick: function (_a) {
                                        var person = _a.person;
                                        location.href = "?persoon=".concat(person.slug);
                                    }
                                },
                                views: {}
                            }];
                    }
                }
                freshConfig = widgetConfig(dom, config);
                link = document.createElement('link');
                apiUrl = process.env.API_URL;
                link.href = "".concat(apiUrl, "/api/legacy/").concat(freshConfig._customerId, "/style.css");
                link.type = 'text/css';
                link.rel = 'stylesheet';
                document.querySelector('head').appendChild(link);
                canRender = true;
                if (!!_dangeriousBypass) return [3 /*break*/, 2];
                return [4 /*yield*/, verifyWidget(freshConfig).then(function (canrenderFlag) {
                        canRender = canrenderFlag;
                    })];
            case 1:
                _b.sent();
                if (!canRender) {
                    return [2 /*return*/, { canRender: canRender }];
                }
                _b.label = 2;
            case 2:
                // Enable event system
                events.init();
                // Enable statistics - this initializes global statistics
                // Once initialized, all widgets will use the same hook.
                statistics.init(freshConfig);
                // Events / Monitoring for this specific widget.
                statistics(freshConfig, dom);
                // Make sure the widget style is set correctly
                widgetStyleDetection(dom, freshConfig);
                //
                // Update text
                renderText.init((_a = freshConfig === null || freshConfig === void 0 ? void 0 : freshConfig.global) === null || _a === void 0 ? void 0 : _a.lang, freshConfig.defaultLang);
                // Add base / scope class
                dom.classList.add('_mnslq-wr');
                return [2 /*return*/, {
                        freshConfig: freshConfig,
                        dom: dom,
                        canRender: canRender,
                    }];
        }
    });
}); };
export default widgetBootstrap;
